import { defineComponent as _defineComponent } from 'vue'
import { useTranslations } from '@/core/translate.mixin';
import TrackingService from '@/core/tracking.service';
import BasketSummaryLines from '@/ui/views/checkout/BasketSummaryLines.vue';
import BasketViewModel = Vertica.LouisPoulsen.Application.Commerce.ViewModels.PointOfSale.BasketViewModel;
import UpdatePointOfSaleShippingDiscountWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.UpdatePointOfSaleShippingDiscountWebRequest;
import { store } from '@/store';
import { computed, onMounted, ref, watch } from 'vue';
import { injectParentValidator } from '@/core/app.service';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketSummaryPOS',
  props: {
    basket: null,
    checkoutUrl: null
  },
  setup(__props: any) {

const props = __props as {
    basket: BasketViewModel,
    checkoutUrl: string
}



const isBasketLocked = computed<boolean>(() => store.getters['basket/isBasketLocked']);

const shippingDiscount = ref<string>(props.basket.shippingDiscount);
watch(() => props.basket.shippingDiscount, () => {
    shippingDiscount.value = props.basket.shippingDiscount;
});

function updateShippingDiscount(request: UpdatePointOfSaleShippingDiscountWebRequest) : Promise<void> {
    return store.dispatch('basket/updatePointOfSaleShippingDiscount', request);
}

const $validator = injectParentValidator();

function validateAndProcessInformation() {
    $validator
        .validateAll()
        .then(processInformation)
        .catch(x => { console.log('catch' + x); });
}

const $router = useRouter();

async function processInformation(isValid: boolean) : Promise<void> {
    if (!isValid) {
        return;
    }
    try {
        $router.push(props.checkoutUrl);
    } catch (err) {}
}

onMounted(() => {
    const dictionary = {
        custom: {
            email: {
                required: t('Pages.Basket.EmailAddressForMarketingRequiredErrorMessage'),
                email: t('Pages.Basket.EmailAddressForMarketingInvalidErrorMessage')
            }
        }
    };
    $validator.localize('en', dictionary);

    if (!props.basket.hasSubmittedMarketingEmailPermission) {
        TrackingService.event('Newsletter in checkout', 'page1', 'CheckoutNudge');
    }
});

function onShippingDiscountChange(newDiscount: string) {
    if (newDiscount === props.basket.shippingDiscount) {
        return;
    }
    updateShippingDiscount({ discount: newDiscount });
}

const { t } = useTranslations();

return { __sfc: true,props, isBasketLocked, shippingDiscount, updateShippingDiscount, $validator, validateAndProcessInformation, $router, processInformation, onShippingDiscountChange, t, BasketSummaryLines }
}

})